<template>
    <div class="grid">
        <div class="unit whole">
            <h1>Set school preferences</h1>
        </div>
    </div>
    <div class="grid">
        <div class="unit whole">
            <div class="panel">
                <v-container>
                    <v-switch v-model="enableMarking" label="Marking" hide-details color="primary"> </v-switch>
                    <div class="ml-13 text-medium-emphasis">
                        Switch off or turn on the marking function for your whole school. When turned off, teachers will
                        be unable to mark work online and all submitted pupil work will be archived without teacher
                        feedback. If a teacher needs to mark work from the archive, their only option will be to print
                        that work and mark on paper.
                    </div>

                    <v-divider class="my-5"></v-divider>

                    <v-switch v-model="askTeacher" label="Ask the teacher" hide-details color="primary"></v-switch>
                    <div class="ml-13 text-medium-emphasis">Enable 'ask the teacher' messaging for pupils.</div>
                </v-container>
            </div>
        </div>
    </div>
    <v-overlay :model-value="!isLoaded.school" class="align-center justify-center">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
    </v-overlay>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';

definePage({ meta: { area: 'preferences' } });

const { snackbarSuccess } = useSnackbar();

const store = useAdminStore();
store.fetchSchool();
const { school, isLoaded } = storeToRefs(store);

const enableMarking = ref(true);
const askTeacher = ref(true);
watch(isLoaded.value, () => {
    if (isLoaded.value.school) {
        enableMarking.value = school.value ? !school.value.bypass_marking : true;
        askTeacher.value = school.value ? school.value.ask_teacher : false;
    }
});

watch([enableMarking, askTeacher], async () => {
    await store.updateSchool({
        bypass_marking: !enableMarking.value,
        ask_teacher: askTeacher.value,
    });
    snackbarSuccess('School preferences updated.');
});
</script>
<style scoped lang="scss"></style>
